module.exports = __webpack_public_path__ + "img/icon-success.86afebe2.png";